import { c as _c } from "react/compiler-runtime";
import { CreditDirection } from "../GroupCard";
import GroupCardActionCreditDirection from "./GroupCardActionCreditDirection";
export default function GroupCardActionNumberInput(t0) {
  const $ = _c(18);
  const {
    label,
    componentId,
    amount,
    creditDirection,
    setAmount,
    setCreditDirection
  } = t0;
  let t1;
  if ($[0] !== setAmount) {
    t1 = e => {
      const value = e.target.value;
      if (value === "") {
        setAmount(null);
        return;
      }
      const numberAmount = parseInt(value);
      if (isNaN(numberAmount)) {
        setAmount(null);
        return;
      }
      if (numberAmount < 0) {
        setAmount(0);
        return;
      }
      setAmount(numberAmount);
    };
    $[0] = setAmount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onChange = t1;
  let t2;
  if ($[2] !== creditDirection || $[3] !== setCreditDirection) {
    t2 = <GroupCardActionCreditDirection creditDirection={creditDirection} setCreditDirection={setCreditDirection} />;
    $[2] = creditDirection;
    $[3] = setCreditDirection;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = amount ?? "";
  let t4;
  if ($[5] !== componentId || $[6] !== onChange || $[7] !== t3) {
    t4 = <input type="number" id={componentId} min={0} value={t3} onChange={onChange} autoComplete="off" className={"tw-form-input tw-block tw-py-3 tw-text-sm tw-px-4 tw-w-full tw-rounded-lg tw-border-0 tw-appearance-none tw-text-white tw-border-iron-650 focus:tw-border-blue-500 tw-peer\n      tw-bg-iron-900 hover:tw-bg-iron-800 focus:tw-bg-iron-900 tw-font-medium tw-caret-primary-300 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-650 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"} placeholder=" " />;
    $[5] = componentId;
    $[6] = onChange;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== componentId || $[10] !== label) {
    t5 = <label htmlFor={componentId} className={"tw-absolute tw-cursor-text tw-text-sm tw-font-medium tw-text-iron-500 tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-[1] tw-origin-[0] tw-bg-iron-900 tw-rounded-lg group-hover:tw-bg-iron-800 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 peer-placeholder-shown:tw-scale-100 \n  peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1"}>{label}</label>;
    $[9] = componentId;
    $[10] = label;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="tw-group tw-w-full tw-relative">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t6) {
    t7 = <div className="tw-flex tw-w-full tw-items-center tw-gap-x-3">{t2}{t6}</div>;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}